import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

export const Attribution = styled(Typography)`
&& {
    padding-top: 15px;
    max-width: 300px;
}
`